import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class QuantityButton extends Vue {
  @Prop({ default: null }) maxValue;
  @Prop({ default: null }) minValue;
  @Prop({ default: 0 }) quantity;

  changeQuantity(value) {
    if (
      (value === 1 && (this.maxValue === null || this.quantity < this.maxValue)) ||
      (value === -1 && (this.minValue === null || this.quantity > this.minValue))
    ) {
      const newQuantity = this.quantity + value;
      this.$emit("on-change-quantity", newQuantity);
    }
  }
}
